import type { PlayerData } from '@/types';

interface PlayerHeaderProps {
  player: PlayerData;
}

export const PlayerHeader = ({ player }: PlayerHeaderProps) => {
  return (
    <div className="section">
      <div className="flex items-center gap-3">
        {player.avatarUrl ? (
          <img
            src={player.avatarUrl}
            alt={player.username}
            className="w-10 h-10 rounded-full flex-shrink-0"
            onError={(e) => {
              // Fallback to initial if image fails to load
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }}
          />
        ) : null}
        <div
          className={`w-10 h-10 bg-crisp-blue-light rounded-full flex items-center justify-center flex-shrink-0 ${player.avatarUrl ? 'hidden' : ''}`}
        >
          <span className="text-crisp-blue font-semibold text-lg">
            {player.username.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-semibold text-base text-crisp-dark truncate">
            {player.username}
          </h2>
          <p className="text-xs text-crisp-gray truncate">
            {player.uuid}
          </p>
        </div>
      </div>
    </div>
  );
};
